import { css } from 'styled-components';

export const PopconfirmStyles = css`
  .ant-popover-message > .anticon {
    top: 8px;
  }
  .ant-popconfirm {
    width: 240px;
  }
  .ant-popconfirm .ant-popover-inner-content {
    padding: 0px;
  }
  .ant-popconfirm .ant-popover-inner {
    padding: var(--spacing-05) 0px var(--spacing-03) 0px;
  }
  .ant-popconfirm .ant-popover-message {
    padding: 0px var(--spacing-05) var(--spacing-06);
    border-bottom: solid 1px var(--border-color);
  }
  .ant-popconfirm .ant-popover-message-title {
    padding: 0px;
  }
  .ant-popconfirm .ant-popover-buttons {
    padding: var(--spacing-03) var(--spacing-05) 0px 0px;
  }
`;
